module.exports = " <div class=Modal__mask v-show=show transition=Modal @click=\"show = false\"> <div class=Modal__wrapper> <div class=Modal__container @click.stop> <span :style=\"'height: 150px; width: 150px; background-color: ' + color\">{{ color }}</span> <slot></slot> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/modals/Modal.vue
// module id = 511
// module chunks = 1